import { Menu as BaseMenu } from '@base-ui/react/menu'

import { cn } from '@gto/ui/cn'

type BaseRadioGroupProps = BaseMenu.RadioGroup.Props

type RadioGroupProps<TValue extends string> = Omit<
  BaseRadioGroupProps,
  'value' | 'defaultValue' | 'onValueChange'
> & {
  value?: TValue
  defaultValue?: TValue
  onValueChange?: (
    value: TValue,
    eventDetails: Parameters<NonNullable<BaseRadioGroupProps['onValueChange']>>[1],
  ) => void
}

/**
 * Visual section of a menu — wraps base-ui's accessibility `RadioGroup` and applies
 * the design-system padding/gap. Wrap one or more `Item`/`CheckboxItem`/
 * `RadioItem` children, optionally preceded by a `GroupLabel`.
 *
 * Generic over the option value so `value`/`onValueChange` carry the consumer's
 * enum/string-literal type instead of base-ui's `any` — callers get an inferred
 * `onValueChange(value)` with no cast.
 */
export const RadioGroup = <TValue extends string>({
  className,
  ...props
}: RadioGroupProps<TValue>) => {
  return (
    <BaseMenu.RadioGroup
      className={cn('flex flex-col gap-0.5', className)}
      {...props}
    />
  )
}
